import React, { Component } from 'react';
import { Dispatch, bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { Box, List, ListItem, ListItemText, Link } from '@mui/material';
import { WithStyles, withStyles } from '@mui/styles';
import { Pagination } from '@mui/material';
import moment from 'moment';

// Contexts
import { withNavigation, withTranslate } from '../../core/TenantProvider';
// Components - Atoms, Organisms,Containers
import APHeading from './../../components/atoms/APHeading';
import APLabel from './../../components/atoms/APLabel';
import { APTableSkeletonLoader } from '../../components/atoms/APSkeletonLoader';
// Files in the same folder
import NotificationsContainerStyle from './styles/NotificationsContainer.style';
// Types
import { LoadingEvent } from '../../core/types/GeneralTypes';
// Reducer
import { ReducerState } from '../../redux/modules';
import { actions as NotificationsActions } from '../../redux/modules/notifications';
import Empty from './assets/empty.svg';
// Constants
import { COMMISSIONS_DETAILED_VIEW, COMMISSIONS_SUMMARY_VIEW, MONTHS_DATA } from '../../core/utils/Constants/Constants';

interface NotificationsContainerProps extends WithStyles<typeof NotificationsContainerStyle> {
    translate: Function,
    getAllNotifications: Function,
    allNotifications: Array<NotificationsItem>,
    unreadCount: number,
    readNotifications: Function,
    navigate: any,
    getUnreadNotificationsCount: Function,
    affiliateDetails: any,
    loadingState: LoadingEvent,
    forTestingCall? : boolean
}

interface NotificationsContainerState {
    notificationsPerPage: number,
    currentPage: number
}

export type NotificationsItem = {
    commission_month: string | null,
    created_on: string,
    customer_name: string,
    customer_id: string,
    notification_id: string,
    notification_type: string,
    paid_date: string | null,
    read_by_affiliate: boolean,
    first_trade: string | null
}

class NotificationsContainer extends Component<NotificationsContainerProps, NotificationsContainerState> {

    constructor(props: any) {
        super(props);
        this.state = {
            notificationsPerPage: 15,
            currentPage: 1,
        };
    }

    componentDidMount(): void {
        const { getAllNotifications, forTestingCall = false } = this.props;
       !forTestingCall && getAllNotifications();
    }

    notificationTypePath(notification: NotificationsItem): void {
        const { navigate } = this.props;
        switch (notification.notification_type) {
            case 'R':
                navigate('/referrals');
                break;
            case 'T':
                navigate('/referrals');
                break;
            case 'P':
                navigate('/commissions');
                break;
            case 'S':
                navigate('/commissions');
                break;
        }
    }

    handleChange = (event: object, value: number) => {
        this.setState({ currentPage: value });
    };

    render() {

        const {
            classes,
            translate,
            allNotifications,
            readNotifications,
            getAllNotifications,
            unreadCount,
            getUnreadNotificationsCount,
            affiliateDetails,
            loadingState
        } = this.props;
        const { notificationsPerPage, currentPage } = this.state;
        const noOfPages = (allNotifications && allNotifications.length > 0) ?
            (Math.ceil(allNotifications.length / notificationsPerPage)) : 1;

        const showCommissions: boolean = affiliateDetails?.affiliate?.commission_view &&
            (affiliateDetails?.affiliate?.commission_view === COMMISSIONS_SUMMARY_VIEW ||
                affiliateDetails?.affiliate?.commission_view === COMMISSIONS_DETAILED_VIEW);

        const commissionsViewType: string = affiliateDetails?.affiliate?.commission_view;

        return (
            <div className={classes.notificationsContainer}>
                <div className={classes.notificationsContainerContent}>
                    {allNotifications && allNotifications.length > 0 ? (
                        <>
                            <div className={classes.notificationsHeader}>
                                <APHeading variant="h4" className={classes.formSectionHeading}>{translate('notifications.heading')}
                                    {allNotifications && allNotifications.length > 0 && (
                                        <span>
                                            {unreadCount > 0 ? (
                                                <Link
                                                    href="#"
                                                    onClick={() => {
                                                        const allNotificationsIds = allNotifications.map((notification) => (
                                                            notification.notification_id
                                                        )).join(',');
                                                        readNotifications({
                                                            'messageids': allNotificationsIds
                                                        });
                                                        getAllNotifications();
                                                        getUnreadNotificationsCount();
                                                    }}
                                                    color="inherit">
                                                    {translate('notifications.mark.all.read')}
                                                </Link>
                                            ) : (<span>{translate('notifications.mark.all.read')}</span>)}
                                        </span>
                                    )}
                                </APHeading>
                            </div>

                            {loadingState === 'LOADING' ?
                                (<APTableSkeletonLoader
                                    module='notification'
                                    skeletonRows={10}
                                />) :
                                <>
                                    <div className={classes.notificationsList}>

                                        <List>
                                            {allNotifications && allNotifications.length > 0 ? (allNotifications
                                                .slice((currentPage - 1) * notificationsPerPage, currentPage * notificationsPerPage)
                                                .map((notification, index) => {
                                                    return (
                                                        (notification.notification_type === 'P' || notification.notification_type === 'S' ? showCommissions : true) &&
                                                        <ListItem
                                                            key={notification.notification_id}
                                                            className={!notification.read_by_affiliate ? classes.unreadNotification : ''}
                                                            button
                                                            onClick={() => {
                                                                readNotifications({
                                                                    "messageids": notification.notification_id
                                                                });
                                                                getUnreadNotificationsCount();
                                                                this.notificationTypePath(notification);
                                                            }}>
                                                            <ListItemText
                                                                primary={getNotificationText(notification, translate, commissionsViewType)} />
                                                            <ListItemText
                                                                className={classes.notificationDate}
                                                                primary={moment(notification.created_on).format('DD MMM YYYY')} />
                                                        </ListItem>
                                                    );
                                                })) : (<h2>{translate('notifications.count.none')} </h2>)}
                                        </List>
                                    </div>

                                    {noOfPages > 1 &&
                                        <Box className={classes.paginationBox}>
                                            <Pagination
                                                count={noOfPages}
                                                page={currentPage}
                                                // defaultPage={1}
                                                onChange={this.handleChange}
                                                shape="rounded"
                                                color="primary"
                                                hidePrevButton={currentPage === 1}
                                                hideNextButton={currentPage === noOfPages}
                                                size="large"
                                                siblingCount={1}
                                            />
                                        </Box>
                                    }
                                </>
                            }
                        </>
                    ) : (loadingState === 'LOADING' ?
                        (<APTableSkeletonLoader
                            module='notification'
                            skeletonRows={10}
                        />) :
                        <div className={classes.notificationsEmpty}>
                            <img src={Empty} alt={translate('notifications.count.none')} />
                            <div className={classes.notificationsEmptyBodyContent}>
                                <APHeading className={classes.notificationsEmptyHeading} variant="h4">
                                    No {translate('notifications.heading')}
                                </APHeading>
                                <APLabel>
                                    {translate('notifications.count.none')}
                                </APLabel>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const getNotificationText = (notification: NotificationsItem, translate: Function, commissionsViewType: string) => {
    const customerId: string = notification.customer_id !== 'NULL' ? notification.customer_id : '';
    const customerName: string = notification.customer_name !== 'NULL' ? notification.customer_name : 'Client';
    const clientDetail: string = commissionsViewType === COMMISSIONS_DETAILED_VIEW ?
        `Client ${customerId}` : customerName;
    const isfirstTrade: boolean = notification.notification_type === 'T' && notification?.first_trade === 'true';

    let formattedMonth: string = '';
    const initialMonthName: string | undefined = notification?.commission_month?.trim();

    if (initialMonthName) {
        const monthNumber: number = MONTHS_DATA.indexOf(initialMonthName);
        const monthName: string = moment().month(Number(monthNumber)).format('MMMM');

        formattedMonth = monthName.charAt(0).toUpperCase() + monthName.slice(1)
    }

    switch (notification.notification_type) {
        case 'R':
            return translate('notifications.registration.text', {
                client: clientDetail
            });
        case 'T':
            return (isfirstTrade ? translate('notifications.first.traded.text', {
                client: clientDetail
            }) : translate('notifications.traded.text', {
                client: clientDetail
            }));
        case 'P':
            return translate('notifications.commission.paid.text', {
                commission_month: formattedMonth,
                paid_date: moment(notification.paid_date).format('DD/MM/YYYY')
            });
        case 'S':
            return translate('notifications.commission.statement.text', {
                commission_month: formattedMonth
            });
        default:
            return '';
    }
};

const mapStateToProps = (store: ReducerState) => ({
    allNotifications: store.notifications.allNotifications,
    unreadCount: store.notifications.unreadCount,
    affiliateDetails: store.user.affiliateDetails,
    loadingState: store.notifications.getAllNotificationsLoadingState,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
    getAllNotifications: NotificationsActions.getAllNotifications,
    readNotifications: NotificationsActions.readNotifications,
    getUnreadNotificationsCount: NotificationsActions.getUnreadNotificationsCount,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(
    withNavigation(withTranslate(
        withStyles(NotificationsContainerStyle)(NotificationsContainer)
    ))
);